/* eslint-disable no-unused-vars */
export enum ListItemIcon {
  account = 'account',
  arrivals = 'arrivals',
  bell = 'bell',
  checkmark = 'checkmark',
  chevron = 'chevron',
  circle = 'circle',
  download = 'download',
  heart = 'heart',
  info = 'info',
  payment = 'payment',
  ribbon = 'ribbon',
  sale = 'sale',
  star = 'star',
  truck = 'truck',
  order = 'order',
  invoice = 'invoice',
  recommendations = 'recommendations',
  faster_checkout = 'faster_checkout'
}

export const ListItemIconColor = {
  blue: 'text-EXPONDO-secondary',
  black: 'text-EXPONDO-black',
} as const;

export interface IconicListItemInterface {
  icon?: ListItemIcon;
  iconColor?: ValueOf<typeof ListItemIconColor>;
  text: String;
  url?: String;
}
